import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppSidebar } from '../app-sidebar/app-sidebar';
import { Backdrop } from '../backdrop/backdrop';
import { SidebarService } from '../../services/sidebar.service';
import { AppDashboardHeader } from '../app-dashboard-header/app-dashboard-header';

@Component({
  selector: 'app-app-layout',
  imports: [
    CommonModule,
    RouterModule,
    AppDashboardHeader,
    AppSidebar,
    Backdrop
  ],
  templateUrl: './app-dashboard-layout.html'
})
export class AppDashboardLayout {
  readonly isExpanded$;
  readonly isHovered$;
  readonly isMobileOpen$;

  constructor(public sidebarService: SidebarService) {
    this.isExpanded$ = this.sidebarService.isExpanded$;
    this.isHovered$ = this.sidebarService.isHovered$;
    this.isMobileOpen$ = this.sidebarService.isMobileOpen$;
  }

  get containerClasses() {
    return [
      'flex-1',
      'transition-all',
      'duration-300',
      'ease-in-out',
      (this.isExpanded$ || this.isHovered$) ? 'xl:ml-[290px]' : 'xl:ml-[90px]',
      this.isMobileOpen$ ? 'ml-0' : ''
    ];
  }
}